import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: "history",
    base: '/plncdb/',
    routes: [{
            path: '/',
            component: () =>
                import ( /* webpackChunkName: "home" */ '../components/common/Home.vue'),
            meta: {
                title: 'Home'
            },
            children: [{
                    path: '/',
                    meta: {
                        title: 'homePage'
                    },
                    component: () =>
                        import ( /* webpackChunkName: "homePage" */ '../components/page/homePage.vue'),
                },
                {
                    path: '/UpdateLog',
                    meta: {
                        title: 'UpdateLog'
                    },
                    component: () =>
                        import ( /* webpackChunkName: "UpdateLog" */ '../components/page/UpdateLog.vue'),
                },
                {
                    path: '/Browse',
                    meta: {
                        title: 'Browse'
                    },
                    component: () =>
                        import ( /* webpackChunkName: "Browse" */ '../components/page/Browse/index.vue'),
                },
                {
                    path: '/JBrowse',
                    meta: {
                        title: 'JBrowse'
                    },
                    component: () =>
                        import ( /* webpackChunkName: "JBrowse" */ '../components/page/JBrowse.vue'),
                },
                {
                    path: '/Efp',
                    meta: {
                        title: 'Efp'
                    },
                    component: () =>
                        import ( /* webpackChunkName: "JBrowse" */ '../components/page/Efp.vue'),
                },
                {
                    path: '/Heatmap',
                    meta: {
                        title: 'Heatmap'
                    },
                    component: () =>
                        import ( /* webpackChunkName: "JBrowse" */ '../components/page/Heatmap.vue'),
                },
                {
                    path: '/EPexplorer',
                    meta: {
                        title: 'EPexplorer'
                    },
                    component: () =>
                        import ( /* webpackChunkName: "JBrowse" */ '../components/page/EPexplorer.vue'),
                },
                {
                    path: '/EPexplorerResult',
                    meta: {
                        title: 'EPexplorerResult'
                    },
                    component: () =>
                        import ( /* webpackChunkName: "JBrowse" */ '../components/page/EPexplorerResult.vue'),
                },
                {
                    path: '/Statistic',
                    meta: {
                        title: 'Statistic'
                    },
                    component: () =>
                        import ( /* webpackChunkName: "JBrowse" */ '../components/page/Statistic.vue'),
                },
                {
                    path: '/Search',
                    meta: {
                        title: 'Search'
                    },
                    component: () =>
                        import ( /* webpackChunkName: "Search" */ '../components/page/Search.vue'),
                },
                {
                    path: '/Blast',
                    meta: {
                        title: 'Blast'
                    },
                    component: () =>
                        import ( /* webpackChunkName: "Search" */ '../components/page/Blast.vue'),
                },
                {
                    path: '/searchList',
                    meta: {
                        title: 'searchList'
                    },
                    component: () =>
                        import ( /* webpackChunkName: "searchList" */ '../components/page/searchList/searchList.vue'),
                },
                {
                    path: '/nunMir',
                    meta: {
                        title: 'nunMir'
                    },
                    component: () =>
                        import ( /* webpackChunkName: "nunMir" */ '../components/page/nunMir/index.vue'),
                },
                {
                    path: '/nunMirGene',
                    meta: {
                        title: 'nunMirGene'
                    },
                    component: () =>
                        import ( /* webpackChunkName: "nunMir" */ '../components/page/nunMirGene/index.vue'),
                },
                {
                    path: '/Eplant',
                    meta: {
                        title: 'plantSvg'
                    },
                    component: () =>
                        import ( /* webpackChunkName: "Eplant" */ '../components/page/plantSvg/index.vue'),
                },
                {
                    path: '/Download',
                    meta: {
                        title: 'Download'
                    },
                    component: () =>
                        import ( /* webpackChunkName: "Download" */ '../components/page/Download.vue'),
                },
                {
                    path: '/ftp',
                    meta: {
                        title: 'ftp'
                    },
                    component: () =>
                        import ( /* webpackChunkName: "Download" */ '../components/page/ftp.vue'),
                },
                {
                    path: '/Documentation',
                    meta: {
                        title: 'Documentation'
                    },
                    component: () =>
                        import ( /* webpackChunkName: "Documentation" */ '../components/page/Documentation.vue'),
                },
                {
                    path: '/Resource',
                    meta: {
                        title: 'Resource'
                    },
                    component: () =>
                        import ( /* webpackChunkName: "Resource" */ '../components/page/Resource.vue'),
                },
                {
                    path: '/Submit',
                    meta: {
                        title: 'Submit'
                    },
                    component: () =>
                        import ( /* webpackChunkName: "Submit" */ '../components/page/Submit.vue'),
                },
                {
                    path: '/Contact',
                    meta: {
                        title: 'Contact'
                    },
                    component: () =>
                        import ( /* webpackChunkName: "Contact" */ '../components/page/Contact.vue'),
                },
                {
                    path: '/Map',
                    meta: {
                        title: 'Map'
                    },
                    component: () =>
                        import ( /* webpackChunkName: "Map" */ '../components/baiduMap/Map.vue'),
                },
                {
                    path: '/SpeciesDetail',
                    meta: {
                        title: 'SpeciesDetail'
                    },
                    component: () =>
                        import ( /* webpackChunkName: "homePage" */ '../components/page/speciesDetail/index.vue'),
                },
            ]
        },
        {
            path: '/detailInfo',
            name: 'detailInfo',
            component: () =>
                import ( /* webpackChunkName: "detailInfo" */ '../components/page/detailInfo.vue'),
            meta: {
                title: 'detailInfo'
            }
        },
        {
            path: '/cytoscape',
            name: 'cytoscape',
            component: () =>
                import ( /* webpackChunkName: "404" */ '../components/page/cytoscape/index.vue'),
            meta: {
                title: '404'
            }
        },
        {
            path: '/404',
            component: () =>
                import ( /* webpackChunkName: "404" */ '../components/error/404.vue'),
            meta: {
                title: '404'
            }
        },
        {
            path: '/403',
            component: () =>
                import ( /* webpackChunkName: "403" */ '../components/error/403.vue'),
            meta: {
                title: '403'
            }
        }
    ]
});